import uuid from 'uuid';

// this is member profile app def id
export const MEMBERS_APP_ID = '14ce28f7-7eb0-3745-22f8-074b0e2401fb';
export const FF_APP_DEF_ID = '14ebe801-d78a-daa9-c9e5-0286a891e46f';

export const DEFAULT_APP_ID = '00000000-0000-0000-0000-000000000000';
export const DEFAULT_APP_SECRET = '00000000-0000-0000-0000-000000000000';
export const DEFAULT_BI_TOKEN = '00000000-0000-0000-0000-000000000000';
export const DEFAULT_USER_ID = uuid.v4();
export const DEFAULT_INSTANCE_ID = '70762c47-18c5-4caf-85ed-4483ac864ed7';
export const DEFAULT_METASITE_ID = '76f56968-6e11-4755-9386-8daf5785b50b';

export const BLOG_APP_SECRET = '8116fcb6-ce7f-4d19-87a8-d0143f14a7e8';
export const BLOG_APP_DEF_ID = '14bcded7-0066-7c35-14d7-466cb3f09103';

export const FORUM_APP_DEF_ID = '14724f35-6794-cd1a-0244-25fd138f9242';
export const FORUM_APP_SECRET = '4ff59840-c08c-4bba-8c66-807541772d3d';

export const DEMO_USER_UID = '12345678-1234-1234-1234-1234567890';
export const DEMO_USER_NAME = 'Demo User';
export const DEMO_METASITE_ID = '00000000-0000-0000-0000-0000000000';

export const MEMBERS_ABOUT_APP_DEF_ID = '14dbef06-cc42-5583-32a7-3abd44da4908';

export const MAX_PAGING_LIMIT = 100;
